import { STATIC_OBS_URL } from '../../consts'

export const culture = [
  {
    url: `${STATIC_OBS_URL}/website/home/about/culture-01.png`,
    title: '愿景',
    subtitle: 'VISION',
    content: '<p>成为全球仿真领域的领跑者</p><p>成为员工实现梦想的最佳平台</p>'
  },
  {
    url: `${STATIC_OBS_URL}/website/home/about/culture-02.png`,
    title: '使命',
    subtitle: 'MISSION',
    content: '<p>推动人类科学技术进步</p><p>仿真未来</p>'
  },
  {
    url: `${STATIC_OBS_URL}/website/home/about/culture-03.png`,
    title: '价值观',
    subtitle: 'VALUE',
    content: `<div><div class="ta">探索创新</div><div class="info">永远保持旺盛的技术好奇心，坚持精益求精的职业素养</div></div>
                    <div><div class="ta">成就客户</div><div class="info">以专业、优质的产品和服务成就客户的成功，做客户值得信赖的创新伙伴</div></div>
                    <div><div class="ta">团队合作</div><div class="info">精诚团结</div></div>
                    <div><div class="ta">持续进步</div><div class="info">每一天都在进步</div></div>
                    <div><div class="ta">诚信勇毅</div><div class="info">诚信负责，敢为人先，勇于担当，坚毅执着</div></div>`
  }
]

export const university = [
  {
    title: '西北工业大学',
    url: 'home/about/university/dd2e2437-c4f2-4923-957f-82b94adb4cbb.png?v=16.05.01'
  },
  {
    title: '北京交通大学',
    url: 'home/about/university/979795ff-8615-4939-864d-bdf730086491.png'
  },
  {
    title: '南京航空航天大学',
    url: 'home/about/university/fbe734e6-cfa5-43e3-b781-9f74d1968f4c.png'
  },
  {
    title: '武汉理工大学',
    url: 'home/about/university/3eb49e72-980c-4abb-ad5b-20317747870c.png'
  },
  {
    title: '中国石油大学',
    url: 'home/about/university/aa9c688e-0918-4d77-83a4-fd3933e07a4b.png'
  },
  {
    title: '北京航空航天大学',
    url: 'home/about/university/7018f01a-f50f-424a-bd6d-f5f70c15f97d.png'
  },
  {
    title: '哈尔滨工程大学',
    url: 'home/about/university/68a69323-9f54-4b26-949b-32ab07fc819e.png'
  },
  {
    title: '中国民航大学',
    url: 'home/about/university/2e987e70-5cd8-43f3-8610-5b83cd8c5005.png'
  },
  {
    title: '北京理工大学',
    url: 'home/about/university/c4c73265-90ab-4f90-9160-414c2a9372a8.png'
  },
  {
    title: '吉林大学',
    url: 'home/about/university/7a843bd0-4d04-4065-a5a9-428ae199683a.png'
  }
]

export const companyAddress = [
  {
    title: '西安子公司',
    address: '陕西省西安市高新区丈八街办锦业一路56号西安研祥城市广场A座2101室 ',
    tel: '4009960325',
    email: 'marketing@globalcrown.com.cn'
  },
  {
    title: '沈阳子公司',
    address: '辽宁省沈阳市皇姑区黄河北大街56-34号中粮广场806室',
    tel: '4009960325',
    email: 'marketing@globalcrown.com.cn'
  },
  {
    title: '上海子公司',
    address: '上海市闵行区莘庄镇沪闵路6088号凯德商务楼二层',
    tel: '4009960325',
    email: 'marketing@globalcrown.com.cn'
  },
  {
    title: '深圳子公司',
    address: '深圳市龙岗区坂田街道象角塘社区坂澜大道107号深圳工业软件园1栋E座1001',
    tel: '4009960325',
    email: 'marketing@globalcrown.com.cn'
  },
  {
    title: '成都办事处',
    address: '',
    tel: '4009960325',
    email: 'marketing@globalcrown.com.cn'
  },
  {
    title: '武汉办事处',
    address: '',
    tel: '4009960325',
    email: 'marketing@globalcrown.com.cn'
  }
]

export const genAxisTick = (count: number): string[][] =>
  Array.from({ length: count }, (_, i) => Array.from({ length: 4 }, (_, j) => `${i}-${j}`))

export const companyTimeline = [
  {
    year: 2003,
    content: `<p>引进国际先进技术，服务国内工业用户</p>`
  },
  {
    year: 2009,
    content: `<p>立足自身技术实力，解决客户实际难题。2005年起，连续5年实现了销售额100%的增长率。</p>`
  },
  {
    year: 2014,
    content: `<p>自主研发国产软件，成就客户创新梦想建立国内系统仿真技术服务标准</p>`
  },
  {
    year: 2019,
    content: ` <p>引领行业发展，加高技术壁垒，自主研发GCAir，持续推出1.0-5.0版本</p> <p>软件成功应用于多家航空航天头部用户， 为软件产业化打下基础。</p>`
  },
  {
    year: 2024,
    content: `<p>发布GCKontrol &GCAir 9.0</p><p>取得ISO 26262认证，引领行业国产替代 实现公司业务高速增长</p>`
  }
]

export const menus = [
  {
    name: '公司简介',
    props: {
      href: '#company-profile'
    }
  },
  {
    name: '发展历程',
    props: {
      href: '#container-history'
    }
  },
  {
    name: '企业文化',
    props: {
      href: '#culture'
    }
  },
  {
    name: '合作伙伴',
    props: {
      href: '#cooperator'
    }
  },
  {
    name: '合作高校',
    props: {
      href: '#university'
    }
  },
  {
    name: '荣誉资质',
    props: {
      href: '#certificate'
    }
  },
  {
    name: '联系我们',
    props: {
      href: '#contact'
    }
  },
  {
    name: '加入我们',
    props: {
      href: 'https://www.zhipin.com/gongsi/job/6f6de1bdb6f8a6331HJ9292-.html?ka=company-jobs',
      rel: 'noreferrer',
      target: '_blank'
    }
  }
]
